export default "__VITE_ASSET__QpiCGUnH__"